// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__sMVeB","header":"ReportDetails_header__3vYnQ","title":"ReportDetails_title__1rj1D","left":"ReportDetails_left__olVe-"};